import casesSlider from '../components/cases-slider/_cases-slider.js';
import whyUsLogosSwiperComponent from '../components/logos/_logos.js';
import createGhostsForAllTitles from '../components/title-block/_title-block.js';
import initGallerySwiper from '../components/gallery/_gallery.js';
import initBlogSwiper from '../components/blog/_blog.js';
import initProcess from '../components/process/_process.js';
import initHeaderScroll from '../components/header/_header-scroll.js';

document.addEventListener('DOMContentLoaded', () => {
	casesSlider();
	whyUsLogosSwiperComponent();
	whyUsLogosSwiperComponent({
		swiperClass: '.js-stack',
		perView: 4.5,
		between: 50
	});
	initGallerySwiper();
	initBlogSwiper();
	initProcess();
	initHeaderScroll();

});
createGhostsForAllTitles();




